/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrdownload1Inputs */

const en_qrdownload1 = /** @type {(inputs: Qrdownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download QR code`)
};

const de_qrdownload1 = /** @type {(inputs: Qrdownload1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`QR-Code herunterladen`)
};

/**
* | output |
* | --- |
* | "Download QR code" |
*
* @param {Qrdownload1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrdownload1 = /** @type {((inputs?: Qrdownload1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrdownload1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrdownload1(inputs)
	return de_qrdownload1(inputs)
});
export { qrdownload1 as "qrDownload" }